"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _sources = require("../../utils/sources");
var _types = require("./types");
/**
 * Handles the syncing of hidden status of backgrounds through the toggling of the eye-ball icon.
 */
function syncBackgroundStatus(backgroundId) {
  return function (dispatch, getState) {
    var _getState = getState(),
      backgrounds = _getState.backgrounds;
    var updatedBackgrounds = (0, _sources.toggleStatus)(backgroundId, backgrounds);
    var action = {
      payload: {
        backgrounds: updatedBackgrounds
      },
      type: _types.BROADCAST_TOGGLE_BACKGROUND_STATUS
    };
    dispatch(action);
  };
}
var _default = exports["default"] = syncBackgroundStatus;